import { Injectable } from "@angular/core";
import { TelemetryService } from "@obg/ngx.global.evo";
import { Subject } from "rxjs";

import { GTM_EVENTS_DICTIONARY } from "./responsible-gaming.consts";

@Injectable({
	providedIn: "root",
})
export class ResponsibleGamingFormService {
	resetForm$ = new Subject<void>();
	private isFormDirty$ = new Subject<boolean>();

	constructor(private telemetryService: TelemetryService) {}

	sendIsFormDirty(formState: boolean | undefined) {
		this.isFormDirty$.next(!!formState);
	}

	getIsFormDirty$(): Subject<boolean> {
		return this.isFormDirty$;
	}

	trackLinkClickGtmAction(key: string) {
		const gtmEventAction = GTM_EVENTS_DICTIONARY[key];

		if (!gtmEventAction) {
			return;
		}

		this.telemetryService.track(gtmEventAction);
	}
}
